module.exports = __webpack_public_path__ + "img/Super-Sam-SunHero-300-large.3138e10a.png";